<div class="wrapper wrapper-medium">
  <div class="header">
    <h1>Administration</h1>
    <p class="marto-10">
      Monitor AI usage and audit access for your firm.
    </p>
  </div>

  <div class="tabs" role="tablist">
    <button
      type="button"
      role="tab"
      class="tab"
      [class.active]="activeTab === 'ai-usage'"
      [attr.aria-selected]="activeTab === 'ai-usage'"
      (click)="setTab('ai-usage')"
    >
      AI Usage
    </button>
    <button
      type="button"
      role="tab"
      class="tab"
      [class.active]="activeTab === 'audit'"
      [attr.aria-selected]="activeTab === 'audit'"
      (click)="setTab('audit')"
    >
      Audit Trail
    </button>
  </div>

  <section *ngIf="activeTab === 'ai-usage'" class="panel">
    <app-ai-usage-admin></app-ai-usage-admin>
  </section>

  <section *ngIf="activeTab === 'audit'" class="panel">
    <app-audit-trail-admin></app-audit-trail-admin>
  </section>
</div>
